import { createLocalePreferencePlugin } from '@plugins/locale-preference'

export default defineNuxtPlugin(createLocalePreferencePlugin())
